/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {adminGetCustomerLog} from '../api'

export const useMutationAdminGetCustomerLog = createReactQueryMutationHook('adminGetCustomerLog', adminGetCustomerLog)
